import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppUpdateService } from './app-update.service';

/** Aviso de que hay una versión nueva, con el botón para recargar (TS569). */
@Component({
  selector: 'app-update-notice',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './update-notice.component.html',
  styleUrls: ['./update-notice.component.scss'],
})
export class UpdateNoticeComponent {
  readonly appUpdate = inject(AppUpdateService);
}
